module.exports = __webpack_public_path__ + "static/media/flood-step-icon.5bd6cf8c.svg";